import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { ifProp } from 'styled-tools';

import buttonStyles from '../../../../../../styles/button';
import { font, color } from '../../../../../../styles/constants';

const Button = styled.button`
  ${buttonStyles}
  border: none;
  ${ifProp(
    'hovered',
    `color: ${color.white}; background: ${color.pelorous};`,
    `color: ${color.grey5}; background: ${color.white};`,
  )}
  padding: 12px;
  border-radius: 0;
  width: 100%;
  text-align: left;
  font-size: ${font.size13};
  font-weight: ${font.lightWeight};

  :last-child {
    border-bottom-right-radius: 4px;
    border-bottom-left-radius: 4px;
  }
`;

const HoverButton = ({ isHovered, hoverMonth, monthIndex, onClick, label }) => (
  <Button
    key={monthIndex}
    hovered={isHovered}
    onMouseEnter={() =>
      typeof hoverMonth === 'function' ? hoverMonth(monthIndex) : 0
    }
    onClick={onClick}
  >
    {label}
  </Button>
);

HoverButton.propTypes = {
  isHovered: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  monthIndex: PropTypes.number,
  hoverMonth: PropTypes.func,
};

export default HoverButton;
